import { Form, Formik } from "formik"
import { CLASS_NAME_DEFAULT } from "../../constants"

interface Props<T> {
  initialValues: T
  validationSchema: any
  onSubmit: (formValues: T) => void
  enableReinitialize?: boolean
  children: React.ReactNode
  className?: string
}

const Wrapper = <T extends {}>({
  onSubmit,
  validationSchema,
  initialValues,
  enableReinitialize = true,
  children,
  className = CLASS_NAME_DEFAULT
}: Props<T>) => (
  <Formik
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
    enableReinitialize={enableReinitialize}
  >
    <Form className={className}>{children}</Form>
  </Formik>
)

export default Wrapper
